import { render, staticRenderFns } from "./CoherentTouchNGoReport.vue?vue&type=template&id=c3e62586&"
import script from "./CoherentTouchNGoReport.vue?vue&type=script&lang=js&"
export * from "./CoherentTouchNGoReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports